<mat-toolbar color="primary" style="height: 49px">
	<div fxFlex fxLayoutAlign="start start" fxLayoutGap="1rem">
		<a href="https://www.cargochief.com/">
			<img alt="C4" class="logoImage" src="./assets/images/C4_Logo_5.png" />
		</a>
		<div *ngIf="isNotAdmin() && showLogout" fxLayout="row" fxLayoutGap="1rem">
			<span
				*ngIf="MENU_OPTIONS?.DASHBOARD"
				class="toolbar-menu textWithIcon"
				routerLink="/dashboard"
			>
				<mat-icon
					[ngClass]="utilService.isActiveClass(['/#/dashboard'], true)"
					class="color-white home-icon"
				>
					home
				</mat-icon>
			</span>

			<span
				(click)="fireViewedProjectsListEvent()"
				*ngIf="MENU_OPTIONS?.PROJECTS"
				class="toolbar-menu textWithIcon"
				id="projects"
				routerLink="/v2/projects"
			>
				<span [ngClass]="utilService.isActiveClass(['/#/projects', '/#/v2/projects'], true)">
					Projects
				</span>
			</span>

			<span
				(click)="fireViewedProjectsListEvent()"
				*ngIf="MENU_OPTIONS?.PROJECTS_BOARD"
				class="toolbar-menu textWithIcon"
				id="projects"
				routerLink="/carriers/projects_board"
			>
				<span [ngClass]="utilService.isActiveClass(['carriers/projects_board'], true)"
					>Projects</span
				>
			</span>

			<span
				*ngIf="MENU_OPTIONS?.BIDS"
				class="toolbar-menu textWithIcon"
				id="bids"
				routerLink="/carriers/bids"
			>
				<span [ngClass]="utilService.isActiveClass(['carriers/bids'], true)">Bids</span>
			</span>

			<span
				*ngIf="MENU_OPTIONS?.CAPACITY"
				class="toolbar-menu textWithIcon"
				id="capacity"
				routerLink="/capacity"
			>
				<span [ngClass]="utilService.isActiveClass(['capacity'], true)">Capacity</span>
			</span>

			<span
				*ngIf="MENU_OPTIONS?.CARRIER_NETWORK"
				class="toolbar-menu textWithIcon"
				id="carrier-network"
				routerLink="/carriers/network"
			>
				<span [ngClass]="utilService.isActiveClass(['carriers/network'], true)">Network</span>
			</span>

			<span
				*ngIf="MENU_OPTIONS?.PRICING"
				class="toolbar-menu textWithIcon"
				id="pricing"
				routerLink="/pricing"
			>
				<span [ngClass]="utilService.isActiveClass(['pricing'], true)">Pricing</span>
			</span>

			<!-- <span class="toolbar-menu textWithIcon" routerLink="/carrier/lanes"*ngIf="MENU_OPTIONS?.LANES" id="lanes" >
				<span [ngClass]="utilService.isActiveClass(['lanes'], true)">Lanes</span>
      		</span> -->
			<span
				(click)="navigateToCarrierFullProfile()"
				*ngIf="utilService.isAccountTypeCarrier()"
				class="toolbar-menu textWithIcon"
				id="carrierProfile"
			>
				<span
					[ngClass]="utilService.isActiveClass(['carriers/' + cargochief.CARRIER?.id], true, true)"
					>Profile</span
				>
			</span>

			<span
				(click)="sharedService.sendCarrierFullProfileEvent(true)"
				*ngIf="MENU_OPTIONS?.NETWORK"
				class="toolbar-menu textWithIcon"
				id="carriers"
				routerLink="{{ environment.V2_CARRIER_NETWORK_PAGE ? '/v2' : '' }}/carriers"
			>
				<span [ngClass]="utilService.isActiveClass(['/#/carriers', '/#/v2/carriers'], true)"
					>Network</span
				>
			</span>

			<span
				(click)="sharedService.closeFullProfileSidenav.next(false)"
				*ngIf="MENU_OPTIONS?.CUSTOMERS"
				class="toolbar-menu textWithIcon"
				id="customers"
				routerLink="/users/customers"
			>
				<span [ngClass]="utilService.isActiveClass(['users/customers'], true)">Customers</span>
			</span>

			<span *ngIf="MENU_OPTIONS?.SCORECARDS" class="toolbar-menu textWithIcon" id="scorecards">
				<span
					[matMenuTriggerFor]="scorecards"
					[ngClass]="utilService.isActiveClass(['users/scorecards'], true)"
					mat-button
					>Scorecards</span
				>

				<mat-menu #scorecards="matMenu">
					<button mat-menu-item routerLink="/users/scorecards/lanes">Lanes</button>
					<button
						*ngIf="isAuthorizedForCustomerScorecard()"
						mat-menu-item
						routerLink="/users/scorecards/customers"
					>
						Customers
					</button>
					<button mat-menu-item routerLink="/users/scorecards/carriers">Carriers</button>
					<button
						mat-menu-item
						routerLink="/users/scorecards/BAPerformanceMetrics"
						*ngIf="MENU_OPTIONS?.BA_PERFORMANCE_METRICS_ENABLED"
					>
						Booking Assistant Performance Metrics
					</button>
				</mat-menu>
			</span>

			<span
				*ngIf="MENU_OPTIONS?.LOADS"
				class="toolbar-menu textWithIcon"
				id="loads"
				routerLink="{{ environment.V2_LOADS_PAGE ? '/v2/loads' : '/users/myquotes' }}"
			>
				<span
					[ngClass]="
						utilService.isActiveClass(['loads', 'myquotes', 'quotedetails', 'load_details'], true)
					"
					>Loads</span
				>
			</span>

			<mat-chip-list *ngIf="isFreeTrial()">
				<mat-chip class="countered-chip mt-8">
					{{
						!utilService.isNullOrUndefined(FREE_TRIAL_DAYS_REMAINING)
							? FREE_TRIAL_DAYS_REMAINING
							: ''
					}}
					days left on your trial
				</mat-chip>
			</mat-chip-list>
		</div>
	</div>

	<div
		*ngIf="isNotAdmin() && showLogout && isDemoAccount()"
		fxFlex
		class="toolbar-menu-active"
		fxLayoutAlign="center center"
	>
		<span>Demo Account</span>
	</div>

	<div
		*ngIf="
			showLogout &&
			(utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper()) &&
			false
		"
		fxFlex
	>
		<span class="color-white" fxLayoutGap="1rem">
			<mat-slide-toggle
				(change)="layoutSwitched()"
				[(ngModel)]="isFullWidthLayout"
				[labelPosition]="'before'"
				class="font-size-13"
			>
				Try Beta UI
			</mat-slide-toggle>
		</span>
	</div>

	<div *ngIf="showSignup" class="font-size-13 cursor-pointer" fxFlex fxLayoutAlign="end end">
		<a [href]="URLS.CONTACT_US"><u class="color-white">Need an account? </u></a>
	</div>

	<div *ngIf="false" fxFlex fxLayoutAlign="center center">
		<span class="color-white" fxLayoutGap="1rem">
			<mat-slide-toggle [checked]="false" [labelPosition]="'before'" class="font-size-13">
				Beta UI
			</mat-slide-toggle>
		</span>
	</div>

	<div *ngIf="showLogout" fxFlex fxLayoutAlign="end center" fxLayoutGap="1rem">
		<mat-chip-list *ngIf="showCapacitySearchNotification">
			<mat-chip (click)="capacityNotificationClicked()" class="capacity-search-notification mt-8">
				Please give us feedback on this rate.
			</mat-chip>
		</mat-chip-list>

		<div *ngIf="MENU_OPTIONS?.QUICK_SEARCH">
			<app-quick-search
				#quickSearchComponent
				(closeCarrierFullProfile)="closeCarrierFullProfile()"
				(openCarrierFullProfile)="openCarrierFullProfile($event)"
				[laneDetails]="laneDetails"
				fxFlex="100"
			></app-quick-search>
		</div>

		<app-notifications></app-notifications>

		<button [matMenuTriggerFor]="menu" class="pr-0" id="logoutMenu" mat-button>
			{{ !utilService.isNullOrUndefined(user.firstName) ? user.firstName : '' }}
			<mat-icon>more_vert</mat-icon>
		</button>
	</div>

	<div *ngIf="showSignin" fxFlex fxLayoutAlign="end end" fxLayoutGap="1rem">
		<span class="color-white font-size-13">Already have an account?</span>
		<span><a mat-raised-button routerLink="/login">Login</a></span>
	</div>
</mat-toolbar>

<mat-menu #menu="matMenu" class="m-t-1 primary-border" xPosition="before">
	<div *ngIf="!utilService.isAccountTypeAdmin()">
		<button
			class="primary-text"
			id="account_settings"
			mat-menu-item
			routerLink="/users/account_settings"
		>
			<span>Account</span>
		</button>

		<app-profile-popover
			#profilePopover
			*ngIf="showLogout"
			[highlightLandingPageSection]="highlightLandingPageSection"
			[showLogout]="showLogout"
		></app-profile-popover>

		<app-notification-popover
			#notificationPopover
			*ngIf="showLogout && environment.SHOW_NOTIFICATIONS"
		></app-notification-popover>

		<button
			*ngIf="utilService.isUserRoleUser() && productsService.TASKS"
			class="primary-text"
			id="tasks"
			mat-menu-item
			routerLink="/users/tasks"
		>
			<span>Tasks</span>
		</button>

		<button
			*ngIf="!utilService.isAccountTypeCarrier()"
			class="primary-text"
			mat-menu-item
			routerLink="/users/settings/excluded_carriers"
		>
			Excluded Carriers
		</button>

		<button
			*ngIf="environment.AUTOMATION_TOOLS_ENABLED && !utilService.isAccountTypeCarrier()"
			[matMenuTriggerFor]="automationTools"
			class="primary-text"
			mat-menu-item
		>
			<span>Automation Tools</span>
		</button>

		<button
			*ngIf="false"
			class="primary-text"
			id="job_status"
			mat-menu-item
			routerLink="/users/auto_match"
		>
			<span>Job Status</span>
		</button>

		<button
			*ngIf="showMenuItem('team') && isManageUsersEnabled()"
			[matMenuTriggerFor]="team"
			class="primary-text"
			id="team"
			mat-menu-item
		>
			<span>Team</span>
		</button>

		<button
			*ngIf="showMenuItem('emailTemplates')"
			class="primary-text"
			mat-menu-item
			routerLink="/users/email_templates"
			[queryParams]="{ templateType: TEMPLATE_TYPE.LOAD_OFFER }"
		>
			Email Templates
		</button>

		<button
			*ngIf="integrationsEnabled()"
			class="primary-text"
			mat-menu-item
			routerLink="/users/integrations"
		>
			<span>Integrations</span>
		</button>

		<a class="primary-text" href="{{ URLS.HELP_CENTER }}" mat-menu-item target="_blank"
			>Help Center</a
		>

		<mat-divider
			*ngIf="USER_ACCOUNT_TYPE !== ACCOUNT_TYPE.ADMIN && utilService.isPaidUser()"
		></mat-divider>
	</div>

	<button (click)="logout()" class="primary-text" id="logout-button" mat-menu-item>
		<span>Logout</span>
	</button>
</mat-menu>

<mat-menu #team="matMenu" xPosition="after" yPosition="below">
	<button
		*ngIf="isManageUsersEnabled()"
		class="primary-text"
		id="manage_users"
		mat-menu-item
		routerLink="/users/manage_users"
	>
		<mat-icon>supervised_user_circle</mat-icon>
		<span>Manage Users</span>
	</button>

	<button
		*ngIf="
			utilService.isAccountTypeBroker() && utilService.isUserRoleAdmin() && utilService.isPaidUser()
		"
		class="primary-text"
		id="usage_report"
		mat-menu-item
		routerLink="/users/usage_report"
	>
		<mat-icon>bar_chart</mat-icon>
		<span>Usage Report</span>
	</button>

	<button
		*ngIf="isEmailRoutingEnabled()"
		class="primary-text"
		id="email_routing"
		mat-menu-item
		routerLink="/users/email_routing"
	>
		<mat-icon>mail</mat-icon>
		<span>Email Routing</span>
	</button>
</mat-menu>

<mat-menu #automationTools="matMenu" xPosition="after" yPosition="below">
	<button class="primary-text" mat-menu-item routerLink="/booking-assistant-automation">
		<span>Booking Assistant</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/rfps"
		*ngIf="showMenuItem('lanesRFP') && !utilService.isAccountTypeCarrier()"
	>
		<span>RFPs</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/loads"
		*ngIf="showMenuItem('bulkMatch') && !utilService.isAccountTypeCarrier()"
	>
		<span>Loads</span>
	</button>
	<button class="primary-text" mat-menu-item routerLink="/users/automation/transactions">
		<span>Transactions</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/carriers"
		*ngIf="showMenuItem('carrierAutomationPage')"
	>
		<span>Carriers</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/projects"
		*ngIf="productsService.PROJECT_CARRIERS && !utilService.isAccountTypeCarrier()"
	>
		<span>Projects</span>
	</button>
</mat-menu>

<div *ngIf="isCarrierFullProfileOpened" class="app-default-background h-100vh">
	<app-lane-details
		#laneDetails
		(closeLaneDetails)="closeLaneDetails(laneDetails)"
		[carrierLaneData]="carrierLaneData"
		[recentFeedbackList]="recentFeedbackList"
	>
	</app-lane-details>
</div>

<app-default-progress-bar *ngIf="isUploadingFile"></app-default-progress-bar>
